import { ApiRequestInterceptor } from "./apiRequest";
import { FOOTER } from "../constants/endpoints/endpoints";

export const fetchFooter = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(FOOTER.footer, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de footer");
    }
};
